/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Appname1Inputs */

const he_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop`)
};

const en_common_appname1 = /** @type {(inputs: Common_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop`)
};

/**
* | output |
* | --- |
* | "Pricedrop" |
*
* @param {Common_Appname1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_appname1 = /** @type {((inputs?: Common_Appname1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Appname1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_appname1(inputs)
	return en_common_appname1(inputs)
});
export { common_appname1 as "common_appName" }